import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AiAgentService } from '../../../../services/ai-agent.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GhlCalendarItemResponse } from '../../../../models/responses/ghl-calendar-item-response';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { UpdateGHLIntegrationRequest } from '../../../../models/requests/update-ghl-integration-request';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GHL_ICON } from '../../../../app.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { map, Observable, startWith } from 'rxjs';
import moment from 'moment-timezone';

@Component({
  selector: 'app-ghl-integration-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    NgFor,
    MatIconModule,
    MatDialogModule,
    AsyncPipe,
    MatSelectModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    NgIf
  ],
  templateUrl: './ghl-integration-dialog.component.html',
  styleUrl: './ghl-integration-dialog.component.scss'
})
export class GhlIntegrationDialogComponent {
  ghlForm!: FormGroup;
  isLoading = false;
  calendars: GhlCalendarItemResponse[] = [];
  ghlIcon: string = GHL_ICON;
  filteredOptions!: Observable<string[]>;
  timeZones: string[] = moment.tz.names();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { integrationId: number, agentId: number, calendarId: string },
    public dialogRef: MatDialogRef<GhlIntegrationDialogComponent>,
    private aiAgentService: AiAgentService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.fetchUserCalendars();
    this.initForm();

  }

  initForm() {
    this.ghlForm = this.formBuilder.group({
      integrationId: [this.data.integrationId],
      agentId: [this.data.agentId],
      selectedCalendar: [''],
      timezone: [''],
    });

    this.filteredOptions = this.ghlForm.controls['timezone'].valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }

  onFormSubmit() {
    if (this.ghlForm.valid) {
      this.isLoading = true;
      const values = this.ghlForm.value;
      const selectedCalendarId = values['selectedCalendar'];
      const calendar = this.calendars.find(x => x.id == selectedCalendarId)

      const request: UpdateGHLIntegrationRequest = {
        agentId: this.data.agentId,
        integrationId: this.data.integrationId,
        calendarId: values['selectedCalendar'],
        timezone: values['timezone'],
        name:calendar!.name
      };

      this.aiAgentService.updateGHLCalendar(request).subscribe({
        next: () => {
          this.isLoading = false;
          this.snackBar.open("Your calendar was saved", 'Close', { duration: 5000 });
          this.dialogRef.close();
        },
        error: () => {
          this.isLoading = true;
          alert('Error from server contact support');
        }
      });
    }
  }

  fetchUserCalendars() {
    this.aiAgentService.fetchGHLCalendars(this.data.integrationId).subscribe(calendars => this.calendars = calendars.calendars)
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.timeZones.filter(option => option.toLowerCase().includes(filterValue));
  }
}
